import React from "react";
import { connect } from "react-redux";
import {
  getArticles,
  getCategories,
  removeArticle,
  createArticle,
} from "../../actions/video";
import { subArticle } from "../../actions/sub";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  UncontrolledAlert,
  Button,
  Modal,
} from "reactstrap";
import qs from "query-string";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";

import DropdownSelection from "../../components/Commons/DropdownSelection";
import SearchBar from "../../components/Commons/SearchBar";
import ArticleTable from "../../components/video/ArticleTable";
import PaginationBar from "../../components/Commons/PaginationBar";
import NewModal from "../../components/video/NewModal";

const CATEGORIES = [
  {
    id: 7,
    parent_id: 6,
    sort: 1,
    name: "live tv",
    display_name: "直播",
    category_id: 0,
    sub_categories: [],
  },
  {
    id: 8,
    parent_id: 6,
    sort: 2,
    name: "news channel",
    display_name: "新聞報導",
    category_id: 0,
    sub_categories: [],
  },
  {
    id: 9,
    parent_id: 6,
    sort: 3,
    name: "interview",
    display_name: "專題訪談",
    category_id: 0,
    sub_categories: [],
  },
  {
    id: 162,
    parent_id: 6,
    sort: 4,
    name: "video_ads",
    display_name: "影片廣告",
    category_id: 0,
    sub_categories: [],
  },
];
class FreelancerPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      per_page: 7,
      alert: "",
      openUserModal: false,
      selectedUser: {},
      activeCategoryType: null,
      selects: {},
      operationModal: false,
      article: {
        categories: [7],
      },
      operationNewModal: false,
    };
    this.goToPage = this.goToPage.bind(this);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.filterCat = this.filterCat.bind(this);
    this.filterAuthor = this.filterAuthor.bind(this);
    this.getCurrentCategory = this.getCurrentCategory.bind(this);
    this.removeArticle = this.removeArticle.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.toggleSelectEvent = this.toggleSelectEvent.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.togglemark = this.togglemark.bind(this);
    this.toggleNewModal = this.toggleNewModal.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  componentDidMount() {
    let urlParams = qs.parse(this.props.search);
    let { category_id } = urlParams;
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      ...this.state,
      ...urlParams,
      activeCategoryType: activeCategoryType,
    });
    this.getCategories();
    this.getArticles({ ...urlParams });
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location !== this.props.location) {
      let urlParams = qs.parse(newProps.search);
      this.getArticles(urlParams);
    }
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(parseInt(value));
    this.setState({
      article: {
        ...article,
        category_ids,
      },
    });
  }

  getCurrentCategory(category_id) {
    var matchRoles = CATEGORIES.filter((value) => {
      return value.id == category_id;
    });
    var activeCategoryType = null;
    if (matchRoles.length) {
      activeCategoryType = matchRoles[0].display_name;
    }
    return activeCategoryType;
  }

  getCategories() {
    this.props.getCategories();
  }

  hideAlert() {
    this.setState({
      alert: "",
    });
  }

  confirmedRemove(row) {
    this.setState({
      alert: "",
    });
    this.props.removeArticle(row.post.id);
  }

  removeArticle(row) {
    this.setState({
      alert: (
        <ReactBSAlert
          warning
          title={`刪除文章 ${row.post.title}?`}
          style={{ backgroundColor: "#ffffff" }}
          onCancel={() => this.hideAlert()}
          onConfirm={() => this.confirmedRemove(row)}
          showCancel
          cancelBtnBsStyle="default"
          cancelBtnText="取消"
          confirmBtnBsStyle="primary"
          confirmBtnText="是的，刪除！"
          btnSize=""
        >
          <small>刪除操作將無法取消</small>
        </ReactBSAlert>
      ),
    });
  }

  getArticles(params) {
    // let urlParams = qs.parse(this.props.search);
    let searchParams = {
      // ...urlParams,
      ...params,
    };
    this.props.getArticles(searchParams);
  }

  goToPage(page) {
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      page,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  filterCat(category_id) {
    const activeCategoryType = this.getCurrentCategory(category_id);
    this.setState({
      activeCategoryType: activeCategoryType,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      category_id,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  filterAuthor(author_id) {
    // const activeCategoryType = this.getCurrentCategory(author_id);
    // this.setState({
    //   activeCategoryType: activeCategoryType
    // });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      author_id,
    };
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  onSearchInputChange(e) {
    let searchStr = e.target.value;
    this.setState({
      title: searchStr,
    });
    let urlParams = qs.parse(this.props.history.location.search);
    let searchParams = {
      ...urlParams,
      title: searchStr,
      page: 1,
    };
    delete searchParams.page;
    this.props.history.push({
      pathname: this.props.pathname,
      search: "?" + qs.stringify(searchParams),
    });
  }

  toggleSelectEvent(checked, index) {
    let selects = this.state.selects;
    selects[index] = checked;
    this.setState({
      selects,
    });
  }

  toggleModal = (state) => {
    this.setState({
      operationModal: !this.state.operationModal,
    });
  };

  togglemark() {
    let selects = this.state.selects;
    let post_category_join_ids = [];
    Object.keys(selects).forEach(function (key) {
      if (selects[key]) {
        post_category_join_ids.push(parseInt(key));
      }
    });
    let type = "is_push_selected";
    let mark = 1;
    this.props.subArticle({
      type,
      mark,
      post_category_join_ids,
    });
    this.setState({
      operationModal: !this.state.operationModal,
      selects: [],
    });
  }

  toggleNewModal = (state) => {
    this.setState({
      operationNewModal: !this.state.operationNewModal,
    });
  };

  submitArticle() {
    let { article } = this.state;
    const category_ids = article.category_ids;
    this.props.createArticle({
      category_ids,
    });
  }

  render() {
    const {
      articles,
      articlesPagination,
      getArticlesRequest,
      categories,
      errorMsg,
      successBackMsg,
      editArticleRequest,
      getArticleRequest,
    } = this.props.video;
    var activeCategoryType = this.state.activeCategoryType;

    const heads = [
      "狀態",
      "作者",
      "標題",
      "分類",
      "發布日期",
      "瀏覽量",
      "操作",
    ];
    const dataAttributes = [
      "status",
      "title",
      "category",
      "author",
      "created_at",
    ];

    return (
      <Container className="mt-4" fluid>
        {this.state.alert}
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text mb-4">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between"></div>
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <DropdownSelection
                  Types={categories}
                  activeType={activeCategoryType}
                  filterType={this.filterCat}
                />
              </div>
              <div className="d-flex align-items-center">
                <SearchBar
                  search_string={this.state.title}
                  onSearchInputChange={this.onSearchInputChange}
                />
                <Button
                  className="btn btn-default"
                  onClick={this.toggleNewModal}
                >
                  添加視頻
                </Button>
              </div>
            </div>
          </CardHeader>
          <ArticleTable
            heads={heads}
            dataAttributes={dataAttributes}
            rows={articles}
            loading={getArticlesRequest}
            remove={this.removeArticle}
            toggleSingle={this.toggleSelectEvent}
            selects={this.state.selects}
            toggleModal={this.toggleModal}
          />
          <CardFooter className="py-4 d-flex justify-content-center">
            {articlesPagination.currentPage ? (
              <PaginationBar
                currentPage={articlesPagination.currentPage}
                totalPages={articlesPagination.lastPage}
                pageNeighbours={1}
                goToPage={(page) => this.goToPage(page)}
              />
            ) : null}
          </CardFooter>
        </Card>
        <Modal
          className="modal-dialog-centered modal-sm"
          isOpen={this.state.operationModal}
          toggle={() => this.toggleModal()}
        >
          <div className="modal-header">
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => this.toggleModal()}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body d-flex flex-column justify-content-center align-items-center">
            {this.props.sub.errorMsg}
            <Button
              color="default"
              outline
              type="button"
              onClick={this.togglemark}
            >
              添加到訂閱推送
            </Button>
          </div>
        </Modal>
        <NewModal
          data={this.state.article}
          handleCheckBoxChange={this.handleCheckBoxChange}
          submitArticle={this.submitArticle}
          loading={editArticleRequest}
          toggleNewModal={this.toggleNewModal}
          operationNewModal={this.state.operationNewModal}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    video: state.video,
    sub: state.sub,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getArticles: (params) => dispatch(getArticles(params)),
    getCategories: (params) => dispatch(getCategories(params)),
    removeArticle: (params) => dispatch(removeArticle(params)),
    createArticle: (params) => dispatch(createArticle(params)),
    subArticle: (params) => dispatch(subArticle(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreelancerPage);
